import React, { useEffect, useMemo, useState } from 'react';

import SnackbarBody from './SnackbarBody';
import { SnackbarContextType, SnackbarFunctionProps } from './types';
import { SnackbarContext } from './utils';

export let SnackbarUtils: null | SnackbarContextType = null;

const Snackbar = ({ children }: { children: any }) => {
  const [open, setOpen] = useState(false);
  const [props, setProps] = useState<SnackbarFunctionProps>({ message: '' });

  const contextValue = useMemo(() => {
    const openSnackbar = (props: SnackbarFunctionProps) => {
      setOpen(true);
      setProps({ iconStatus: 'success', ...props });
    };

    const openErrorSnackbar = (props: SnackbarFunctionProps) => {
      setOpen(true);
      setProps({ ...props, appearance: 'error' });
    };

    const closeSnackbar = () => {
      setOpen(false);
    };

    return {
      closeSnackbar: closeSnackbar,
      showErrorSnackbar: openErrorSnackbar,
      showSnackbar: openSnackbar,
    };
  }, [setOpen]);

  const onClose = contextValue.closeSnackbar;

  useEffect(() => {
    SnackbarUtils = contextValue;

    return () => {
      SnackbarUtils = null;
    };
  }, [contextValue]);

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
      <SnackbarBody open={open} onClose={onClose} {...props} />
    </SnackbarContext.Provider>
  );
};

export default Snackbar;
